export default "__VITE_ASSET__d566cd34__"